import { GeneralStore, GENERAL_STORE, ProductStore, PRODUCT_STORE } from 'store'

export type ProductsPageProps = {
  [PRODUCT_STORE]?: ProductStore
  [GENERAL_STORE]?: GeneralStore
}

export enum ProductTableExpandableEntities {
  AGREEMENT = 'agreement',
  PROJECT = 'project'
}
